import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

function selectFilterOption() {
    return true;
}

class ScreensTypeahead extends Component {
    static propTypes = {
        labelId: PropTypes.string,
        required: PropTypes.bool,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        isMulti: PropTypes.bool,
        animatedPlaceholder: PropTypes.bool,
        renderSectionTitle: PropTypes.func,
        renderMultiSuggestion: PropTypes.func,
        screenSizes: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
            }),
        )
    };

    static defaultProps = {
        labelId: 'screen',
        screenSizes: [],
        renderMultiSuggestion
    };

    constructor(props) {
        super(props);

        this.state = {
            options: props.screenSizes
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getSuggestions = value => {
        const { screenSizes } = this.props;
        const inputValue = value.trim().toLowerCase();
        const suggestions = !value ? screenSizes : screenSizes
            .filter(screenSize => screenSize
                .name
                .toLowerCase()
                .includes(inputValue)
            );

        if (this._isMounted)
            this.setState({ options: suggestions });
    };

    render() {
        const {
            required,
            error,
            labelId,
            isMulti,
            animatedPlaceholder,
            value,
            onChangeSuggestion,
            renderSectionTitle,
            renderMultiSuggestion,
            t
        } = this.props;
        const { options } = this.state;

        const formattedOptions = options.map(screen => ({
            label: screen.name,
            value: screen.id
        }));

        return (
            <MultiTypeahead
                required={required}
                error={error}
                titleId={labelId}
                isMulti={isMulti}
                isClearable
                backspaceRemovesValue
                animatedPlaceholder={animatedPlaceholder}
                options={formattedOptions}
                value={value}
                handleSuggestionsFetchRequested={this.getSuggestions}
                onChangeSuggestion={onChangeSuggestion}
                selectFilterOption={selectFilterOption}
                formatGroupLabel={renderSectionTitle}
                formatOptionLabel={renderMultiSuggestion}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ infrastructure }) => ({
    screenSizes: infrastructure.screenSizes.map(item => ({ id: item.id, name: String(item.size) }))
});

export default compose(withTranslation('mobiledevices'), connect(mapStateToProps))(ScreensTypeahead);
